
import moment from "moment";
import { EntityRepository, Repository } from "typeorm";
import { AttendanceEntity } from "../entities/attendance.entity";
import { EmployeeAttendanceQueryResponse } from "./emp-attn.query.response";
import { ShiftWiseEmpCountResponse } from "./shift-emp-count.response";
import { CommonResponse } from "@gtpl/shared-models/masters";
import appSettings from "apps/services/config";

@EntityRepository(AttendanceEntity)
export class AttendanceRepository extends Repository<AttendanceEntity> {

    constructor() {
        super();
    }

    async getAttendanceRecordsByDate(date: string, departmentId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, employee_name, in_time, out_time, department_id, shift, count(1) as count `)
            .where(` DATE = '${date}' AND present_status = "P" AND is_active = true `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        // query.groupBy(` department_id`)
        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }

    async getEmpAttenRecordByDateEmpCode(date: string, empCode?: string): Promise<EmployeeAttendanceQueryResponse> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, employee_name, in_time, out_time, department_id, shift `)
            .where(` DATE = '${date}' AND present_status = "P"`);
        if (empCode) {
            query.andWhere(` employee_code = '${empCode}' `)
        }
        return await query.getRawOne();
    }

    // async getAttendanceRecordsByMonth(year:number, month: number, departmentId?: number, unitId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
    //     console.log(unitId)
    //     const query = this.createQueryBuilder('attendance')
    //         .select(` date, employee_id, employee_code, employee_name, present_status, department_id, shift, unit_id, day `)
    //         .where(` month = '${month}' And year = '${year}' `);
    //     if (departmentId) {
    //         query.andWhere(` department_id = ${departmentId} `)
    //     }
    //     if (unitId) {
    //         query.andWhere(` unit_id = ${unitId} `)
    //     }
    //     // query.groupBy(` department_id`)
    //     query.orderBy(` employee_code, day`)
    //     return await query.getRawMany();
    // }

    async getAttendanceRecordsByMonth(year: number, month: number, departmentId?: number, unitId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
        const startDate: any = moment(new Date(year, month - 2, 26), "Asia/Calcutta").format('YYYY-MM-DD'); //.toISOString().split('T')[0];
        const endDate: any = moment(new Date(year, month - 1, 25), "Asia/Calcutta").format('YYYY-MM-DD'); // .toISOString().split('T')[0];
        let query = `SELECT 
            attendance.date, 
            attendance.employee_id, 
            attendance.employee_code, 
            attendance.employee_name, 
            attendance.present_status, 
            attendance.leave_status,
            attendance.department_id, 
            attendance.shift, 
            attendance.unit_id, 
            attendance.day, 
            ew.week_off_day AS weekOffDay,
            ed.employee_type AS employeeType
        FROM ` + appSettings.hrms_db + `.attendance 
        LEFT JOIN ` + appSettings.hrms_db + `.employee_week_off_uploads ew ON attendance.employee_code = ew.employee_code 
        LEFT JOIN ` + appSettings.masters_db + `.employee_details ed ON attendance.employee_code = ed.employee_code
        WHERE attendance.date >= '${startDate}' AND attendance.date <= '${endDate}' AND ed.employee_type = 'Salaried Form'`;
    
        // Add the optional filters
        if (departmentId) {
            query += ` AND attendance.department_id = '${departmentId}'`;
        }
        if (unitId) {
            query += ` AND attendance.unit_id = '${unitId}'`;
        }
    
        // Add the ORDER BY clause
        query += ` ORDER BY attendance.date`;
    
        // Execute the query and return the results
        const result = await this.query(query);
        return result;
    }
    
    
    
   
    async getMonthRecordsForEmp(year:number,employeeId: number, month: number, departmentId?: string, shift?: string): Promise<EmployeeAttendanceQueryResponse[]> {
        // Calculate the previous month
        const startDate: any = moment(new Date(year, month - 2, 26), "Asia/Calcutta").format('YYYY-MM-DD'); //.toISOString().split('T')[0];
        const endDate: any = moment(new Date(year, month - 1, 25), "Asia/Calcutta").format('YYYY-MM-DD'); // .toISOString().split('T')[0];
        // console.log(endDate,'bbbbbbb')
    
        const query = this.createQueryBuilder('attendance')
            .select(`date,employee_id, employee_code, employee_name, present_status, department_id, shift, count(1) as count, punch_status`)
            .where(`date >= '${startDate}' AND date <= '${endDate}' AND employee_id = ${employeeId}`);
        
        if (departmentId) {
            query.andWhere(`department_id = ${departmentId}`);
        }
        if (shift) {
            query.andWhere(`shift = ${shift}`);
        }
        
        query.groupBy(`present_status, punch_status`);
    
        return await query.getRawMany();
    }

    async getWorkingHoursAttendanceRecordsByDate(startDate: string, endDate: string, departmentId?: number): Promise<
        EmployeeAttendanceQueryResponse> {
        const query = this.createQueryBuilder('attendance')
            .select("SUM(IF(HOUR(TIMEDIFF(out_time,in_time))<8,IF(present_status='P',1,0),0)) AS lh, \
            SUM(IF(((in_time!='0000-00-00 00:00:00' AND out_time='0000-00-00 00:00:00') OR TIMEDIFF(out_time,in_time)='00:00:00' ),IF(present_status='P',1,0),0)) AS sm, \
            SUM(IF(`present_status`='WFH',1,0)) AS wfh,SUM(IF(`present_status`='A',1,0)) AS absent, \
            SUM(IF(`present_status`='L',1,0)) AS leaves")
            .where(` date BETWEEN '${startDate}' AND '${endDate}'`);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        return await query.getRawOne();
    }

    async getWorkingHoursTopRecordsByDate(fromDate: string, toDate: string, departmentId?: number): Promise<
        any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_code,employee_Name,COUNT(employee_code) AS days_less_than_8_hours,TIMEDIFF(out_time,in_time) AS total_hours")
            .where(`HOUR(TIMEDIFF(out_time,in_time))>0 AND HOUR(TIMEDIFF(out_time,in_time))<8 AND DATE BETWEEN '${fromDate}' AND '${toDate}' AND present_status='P' GROUP BY employee_code ORDER BY days_less_than_8_hours DESC, total_hours ASC LIMIT 5`)

        console.log()
        // if (departmentId) {
        //     query.andWhere(` department_id = ${departmentId} `)
        // }
        return await query.getRawMany();
    }

    async getSwipeMissingTopRecordsByDate(fromDate: string, toDate: string, departmentId?: number): Promise<
        any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_Name,COUNT(1) AS no_of_days_swipe_miss,TIMEDIFF(out_time,in_time) AS time_diff,out_time")
            .where(`((in_time!='0000-00-00 00:00:00' AND out_time='0000-00-00 00:00:00') OR TIMEDIFF(out_time,in_time)='00:00:00' ) AND DATE BETWEEN '${fromDate}' AND '${toDate}' AND present_status='P' GROUP BY employee_code ORDER BY no_of_days_swipe_miss DESC LIMIT 5`)

        // if (departmentId) {
        //     query.andWhere(` department_id = ${departmentId} `)
        // }
        const data = await query.getRawMany();
        return data
    }

    async getTopWFHRecordsByDate(fromDate: string, toDate: string, departmentId?: number): Promise<
        any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_code,employee_Name,COUNT(1) AS no_of_wfh")
            .where(`DATE BETWEEN '${fromDate}' AND '${toDate}' AND present_status='WFH' GROUP BY employee_code
          ORDER BY no_of_wfh DESC LIMIT 5`)
        return await query.getRawMany();
    }

    async getTopLeaveRecordsByDate(fromDate: string, toDate: string, departmentId?: number): Promise<
        any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_name,COUNT(1) AS no_of_leave_days")
            .where(`DATE BETWEEN '${fromDate}' AND '${toDate}' AND present_status='L' GROUP BY employee_code ORDER BY no_of_leave_days DESC LIMIT 5`)
        return await query.getRawMany();
    }
    async getTodayAttendanceRecordsByDate(date: string): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, employee_name, in_time, out_time, department_id, shift, count(1) as count `)
            .where(` DATE = '${date}' AND is_active = true `);

        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }

  async getPresentAttendanceRecordsByDate(date: string): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, department_id, shift, count(1) as count `)
            .where(` DATE = '${date}' AND present_status = "P" AND is_active = true `);
        // query.groupBy(` `)
        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }

//  async getLeaveAttendanceRecordsByDate(date: string, departmentId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
//         const query = this.createQueryBuilder('attendance')
//             .select(` employee_id, employee_code, department_id, shift, count(1) as count `)
//             .where(` DATE = '${date}' AND present_status = "L" AND is_active = true `);
//         if (departmentId) {
//             query.andWhere(` department_id = ${departmentId} `)
//         }
//         // query.groupBy(` `)
//         query.orderBy(` employee_id`)
//         return await query.getRawMany();
//     }


// async getAbsentAttendanceRecordsByDate(date: string, departmentId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
//         const query = this.createQueryBuilder('attendance')
//             .select(` employee_id, employee_code, department_id, shift, count(1) as count `)
//             .where(` DATE = '${date}' AND present_status = "A" AND is_active = true `);
//         if (departmentId) {
//             query.andWhere(` department_id = ${departmentId} `)
//         }
//         // query.groupBy(` `)
//         query.orderBy(` employee_id`)
//         return await query.getRawMany();
//     }

async getOtherAttendanceRecordsByDate(date: string,): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` count(1) as count`)
            .where(` DATE = '${date}' AND present_status IN ('OD', 'CO') AND is_active = true `);
       
        // query.groupBy(` `)
        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }
    async getInPunchMissAttendanceRecordsByDate(date: string): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, count(1) as count `)
            .where(` DATE = '${date}' AND out_time IS NOT NULL AND (in_time IS NULL ) AND is_active = true `);

        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }

    async getOutPunchMissAttendanceRecordsByDate(date: string): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, count(1) as count `)
            .where(` DATE = '${date}' AND in_time IS NOT NULL AND (out_time IS NULL ) AND is_active = true `);

        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }

    async getLessThenEightHrAttendanceRecordsByDate(date: string): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` count(1) as count `)
            .where(` DATE = '${date}' AND in_time IS NOT NULL AND (out_time IS NOT NULL OR (HOUR(TIMEDIFF(out_time, in_time)) < 8 )) AND is_active = true `);

        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }
    async getWfhAttendanceRecordsByDate(date: string, departmentId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, department_id, shift, count(1) as count `)
            .where(` DATE = '${date}' AND present_status = "WFH" AND is_active = true `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        // query.groupBy(` `)
        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }

    async getAbsentAttendanceRecordsByDate(date: string, departmentId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, department_id, shift, count(1) as count `)
            .where(` DATE = '${date}' AND present_status = "A" AND is_active = true `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        // query.groupBy(` `)
        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }

    async getLeaveAttendanceRecordsByDate(date: string, departmentId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, department_id, shift, count(1) as count `)
            .where(` DATE = '${date}' AND present_status = "L" AND is_active = true `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        // query.groupBy(` `)
        query.orderBy(` employee_id`)
        return await query.getRawMany();
    }



    async getEmpAttendanceRecordByDate(date: string, empCode: string): Promise<EmployeeAttendanceQueryResponse> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, department_id, shift, present_status, log_date, download_date, shift_group, in_time, out_time, flag`)
            .where(` date = '${date}' AND employee_code = '${empCode}' `)
        return await query.getRawOne();
    }

    async getAttendanceRecordsByDateAndShift(date: string, shift?: string, unitId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` employee_id, employee_code, unit_id, department_id, shift, count(1) as count `)
            .where(` DATE = '${date}' AND present_status = "P"  AND is_active = true`);
        if (shift) {
            query.andWhere(` shift = '${shift}' `)
        }
        if (unitId) {
            query.andWhere(` unit_id = '${unitId}' `)
        }
        query.groupBy(` department_id, shift`)
        query.orderBy(` shift, department_id`)
        return await query.getRawMany();
    }

    async getShiftWiseAttendanceByDate(fromDate: string, toDate: string, shift?: string): Promise<EmployeeAttendanceQueryResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` shift, count(1) as count, log_date `)
            .where(` DATE(log_date) BETWEEN '${fromDate}' AND '${toDate}' AND present_status = "P" `);
        if (shift) {
            query.andWhere(` shift = '${shift}' `)
        }
        query.groupBy(` shift, DATE(log_date)`)
        query.orderBy(` shift, DATE(log_date)`)
        return await query.getRawMany();
    }

    async getShiftWiseEmpCountByDate(date: string, shift?: string): Promise<ShiftWiseEmpCountResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` shift, count(1) as count `)
            .where(` date = '${date}' `);
        if (shift) {
            query.andWhere(` shift = '${shift}' `)
        }
        return await query.getRawMany();
    }

    async getDeptEmpCountShiftWise(date: string, deptId?: number, shift?: string): Promise<EmployeeAttendanceQueryResponse> {
        const query = this.createQueryBuilder('')
            .select(` department_id, shift, count(1) as count`)
            .where(` date = '${date}' `);
        if (shift) {
            query.andWhere(` shift = '${shift}' `)
        }
        if (deptId) {
            query.andWhere(` department_id = '${deptId}'`)
        }
        return await query.getRawOne();
    }
    async getTotalAbsentsInMonth(fromDate: string, toDate: string): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select(`employee_code,employee_name AS empname,COUNT(employee_code) AS count`)
            .where(`present_status="A" AND DATE BETWEEN '${fromDate}' AND '${toDate}' AND is_active = true GROUP BY employee_code ORDER BY COUNT(employee_code) DESC LIMIT 10`)
        return await query.getRawMany();
    }

    async getTotalLessWorkingHoursInMonth(fromDate: string, toDate: string): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select(`employee_code,employee_name AS empname,COUNT(employee_code) AS days_less_than_8_hours, SUM(HOUR(TIMEDIFF(out_time,in_time))) AS total_hours`)
            .where(`present_status="P" AND HOUR(TIMEDIFF(out_time,in_time))>= 0 AND HOUR(TIMEDIFF(out_time,in_time))<8 AND DATE BETWEEN '${fromDate}' AND '${toDate}' AND is_active = true GROUP BY employee_code ORDER BY days_less_than_8_hours DESC LIMIT 10`)
        return await query.getRawMany();
    }

    async getTotalLessWorkingHoursData(fromDate: string, toDate: string): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select(`employee_code AS employeeCode, employee_name AS employeeName, date AS date, in_time AS inTime, out_time AS outTime, shift as shift, Concat(HOUR(TIMEDIFF(out_time, in_time)), ':' , MINUTE(TIMEDIFF(out_time, in_time)) % 60) AS totalHours`)
            .where(`present_status="P" AND in_time IS NOT NULL AND (out_time IS NULL OR (shift = 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 12 AND (MINUTE(TIMEDIFF(out_time, in_time)) % 60) < 55)  OR (shift = 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 11) OR (shift != 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 8 AND (MINUTE(TIMEDIFF(out_time, in_time)) % 60) < 55) OR (shift != 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 7)) AND DATE BETWEEN '${fromDate}' AND '${toDate}' AND hr_status = false AND is_active = true ORDER BY date DESC `)
        return await query.getRawMany();
    }

    async getCriteriaNotMatchingData(fromDate: string, toDate: string): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select(`employee_code AS employeeCode, employee_name AS employeeName, date AS date, in_time AS inTime, out_time AS outTime, shift as shift, Concat(HOUR(TIMEDIFF(out_time, in_time)), ':' , MINUTE(TIMEDIFF(out_time, in_time)) % 60) AS totalHours, present_status as presentStatus, reason as reason `)
            .where(` in_time IS NOT NULL AND (out_time IS NULL OR (shift = 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 12  AND (MINUTE(TIMEDIFF(out_time, in_time)) % 60) < 55) OR (shift = 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 11) OR (shift != 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 8 AND (MINUTE(TIMEDIFF(out_time, in_time)) % 60) < 55) OR (shift != 'X1 Shift' AND HOUR(TIMEDIFF(out_time, in_time)) < 7)) AND DATE BETWEEN '${fromDate}' AND '${toDate}' AND hr_status = true AND is_active = true ORDER BY date DESC `)
        return await query.getRawMany();
    }

    async getDailyShiftWiseEmpCountByDate(date: string, shift?: string): Promise<ShiftWiseEmpCountResponse[]> {
        const query = this.createQueryBuilder('attendance')
            .select(` shift, count(1) as count `)
            .where(` date = '${date}'  AND is_active = true `);
        if (shift) {
            query.andWhere(` shift = '${shift}' `)
        }
        return await query.getRawMany();
    }

    async getDailyWorkingHoursAttendanceRecordsByDate(startDate: string, endDate: string, departmentId?: number): Promise<EmployeeAttendanceQueryResponse> {
        const query = this.createQueryBuilder('attendance')
            .select("SUM(IF(HOUR(TIMEDIFF(out_time,in_time))<8,IF(present_status='P',1,0),0)) AS lh, \
            SUM(IF(((in_time!='0000-00-00 00:00:00' AND out_time='0000-00-00 00:00:00') OR TIMEDIFF(out_time,in_time)='00:00:00' ),IF(present_status='P',1,0),0)) AS sm, \
            SUM(IF((in_time IS NOT NULL AND out_time IS NULL ),IF(present_status='P',1,0),0)) AS present, \
            SUM(IF(`present_status`='WFH',1,0)) AS wfh, \ SUM(IF(`present_status`='A',1,0)) AS absent, \
            SUM(IF(`present_status`='L',1,0)) AS leaves")
            .where(` date BETWEEN '${startDate}' AND '${endDate}'  AND is_active = true `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        return await query.getRawOne();
    }

    async getDailyWorkingHoursTopRecordsByDate(date: string, departmentId?: number): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_Name,TIMEDIFF(out_time,in_time) AS time_diff")
            .where(`HOUR(TIMEDIFF(out_time,in_time)) > 0 AND HOUR(TIMEDIFF(out_time,in_time))<8 AND DATE='${date}' AND present_status='P' ORDER BY time_diff ASC LIMIT 5`)

        // if (departmentId) {
        //     query.andWhere(` department_id = ${departmentId} `)
        // }
        return await query.getRawMany();
    }

    async getDailySwipeMissingTopRecordsByDate(date: string, departmentId?: number): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_Name,TIMEDIFF(out_time,in_time) AS time_diff,out_time")
            .where(`((in_time!='0000-00-00 00:00:00' AND out_time='0000-00-00 00:00:00') OR TIMEDIFF(out_time,in_time)='00:00:00' ) AND DATE='${date}' AND present_status='P' AND is_active = true ORDER BY in_time DESC LIMIT 5`)

        // if (departmentId) {
        //     query.andWhere(` department_id = ${departmentId} `)
        // }
        const data = await query.getRawMany();
        return data
    }
    async getDailyTopWFHRecordsByDate(date: string, departmentId?: number): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_Name,TIMEDIFF(out_time,in_time) AS time_diff")
            .where(`HOUR(TIMEDIFF(out_time,in_time)) AND HOUR(TIMEDIFF(out_time,in_time)) AND DATE='${date}' AND present_status='WFH' ORDER BY employee_code ASC LIMIT 5`)

        console.log()
        // if (departmentId) {
        //     query.andWhere(` department_id = ${departmentId} `)
        // }
        return await query.getRawMany();
    }

    async getDailyTopLeaveRecordsByDate(date: string, departmentId?: number): Promise<any[]> {
        const query = this.createQueryBuilder('attendance')
            .select("employee_Name,TIMEDIFF(out_time,in_time) AS time_diff")
            .where(`DATE='${date}' AND present_status='L' ORDER BY employee_code ASC LIMIT 5`)

        console.log()
        // if (departmentId) {
        //     query.andWhere(` department_id = ${departmentId} `)
        // }
        return await query.getRawMany();
    }

    async getDailyUnitWiseAttendanceRecordsByDate(startDate: string, endDate: string, unitId?: number, departmentId?: number): Promise<EmployeeAttendanceQueryResponse> {
        const query = this.createQueryBuilder('attendance')
            .select("SUM(IF(HOUR(TIMEDIFF(out_time,in_time))<7, IF(present_status='P',1,0),0)) AS lh, \
            SUM(IF((in_time IS NOT NULL AND out_time IS NULL), IF(present_status='P',1,0),0)) AS sm, SUM(IF(`present_status`='P',1,0)) AS present, SUM(IF(`present_status`='A',1,0)) AS absent, \
            SUM(IF(`present_status`='L',1,0)) AS leaves, count(employee_code) as totalCount")
            .where(` date BETWEEN '${startDate}' AND '${endDate}' AND unit_id = '${unitId}' AND is_active = true `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        return await query.getRawOne();
    }


    // async getWorkerAttendanceRecordsByMonth(year: number, month: number, departmentId?: number, unitId?: number): Promise<EmployeeAttendanceQueryResponse[]> {
    //     try {
           
    //         let queryBuilder = this.createQueryBuilder('attendance')
    //             .select(`attendance.date, attendance.employee_id, attendance.employee_code, attendance.employee_name, attendance.present_status, attendance.department_id, attendance.shift, attendance.unit_id, attendance.day, ew.week_off_day as weekOffDay`)
    //             .leftJoin('employee_week_off_uploads', 'ew', 'attendance.employee_code = ew.employee_code')
    //             .where(` year = '${year}' AND month = '${month}' `);

    //         if (departmentId) {
    //             queryBuilder = queryBuilder.andWhere(`department_id = :departmentId`, { departmentId });
    //         }
    //         if (unitId) {
    //             queryBuilder = queryBuilder.andWhere(`unit_id = :unitId`, { unitId });
    //         }
    //         queryBuilder = queryBuilder.orderBy(`attendance.date`);
    //         return await queryBuilder.getRawMany();
    //     } catch (error) {
    //         console.error("Error in getAttendanceRecordsByMonth:", error);
    //         throw error;
    //     }
    // }

    async getWorkerAttendanceRecordsByMonth(year: number, month: number, departmentId?: number, unitId?: number, category?:string): Promise<EmployeeAttendanceQueryResponse[]> {
        // Format the start and end dates
        const prevMonth = month - 1
        
    
        // Construct the base query string
        let query = `SELECT 
            attendance.date, 
            attendance.employee_id, 
            attendance.employee_code, 
            attendance.employee_name, 
            attendance.present_status, 
            attendance.department_id, 
            attendance.shift, 
            attendance.unit_id, 
            attendance.day, 
            ew.week_off_day AS weekOffDay,
            ed.employee_type AS employeeType,
            ed.emp_category
        FROM 
            attendance 
        LEFT JOIN 
            employee_week_off_uploads ew 
        ON 
            attendance.employee_code = ew.employee_code 
        LEFT JOIN erpx_dev_masters.employee_details ed
        ON attendance.employee_code = ed.employee_code
        WHERE 
            attendance.year= '${year}' 
            AND attendance.month = '${month}' 
            AND ed.employee_type = 'Labour Form'
            AND ed.emp_category = 'In-House'`;
    
        // Add the optional filters
        if (departmentId) {
            query += ` AND attendance.department_id = '${departmentId}'`;
        }
        if (unitId) {
            query += ` AND attendance.unit_id = '${unitId}'`;
        }

        if(category){
            query += ` AND ed.emp_category = '${category}'`;
        }


    
        // Add the ORDER BY clause
        query += ` ORDER BY attendance.date`;
    
        // Execute the query and return the results
        const result = await this.query(query);
        return result;
    }
    async getWorkerMonthRecordsForEmp(year:number,employeeId: number, month: number, departmentId?: string, shift?: string): Promise<EmployeeAttendanceQueryResponse[]> {
        // Calculate the previous month
        const prevMonth = month - 1
    
        const query = this.createQueryBuilder('attendance')
            .select(`date,employee_id, employee_code, employee_name, present_status, department_id, shift, count(1) as count, punch_status`)
            .where(` year = '${year}' AND month = '${month}' AND employee_id = ${employeeId} `);

        
        if (departmentId) {
            query.andWhere(`department_id = ${departmentId}`);
        }
        if (shift) {
            query.andWhere(`shift = ${shift}`);
        }
        
        query.groupBy(`present_status, punch_status`);
    
        return await query.getRawMany();
    }

    async getWorkersIncentiveHrsByMonth(year: number, month: number, departmentId?: number, unitId?: number,category?:string): Promise<CommonResponse[]> {
        const prevMonth = month - 1
        let query = `SELECT attendance.date, attendance.employee_id, attendance.employee_code, attendance.employee_name,attendance.department_id, attendance.shift,attendance.present_status as presentStatus, attendance.unit_id, attendance.day, ed.employee_type AS employeeType,ed.emp_category,ed.contractor_name AS contractorName, c.total_hours as totalHours FROM `+appSettings.hrms_db +`.attendance
        LEFT JOIN ` + appSettings.masters_db +`.employee_details ed ON attendance.employee_code = ed.employee_code
        LEFT JOIN `+appSettings.hrms_db +`.consolidated_attendance_log c ON c.employee_code = attendance.employee_code AND c.log_date = attendance.date
        WHERE 
            attendance.year= '${year}' 
            AND attendance.month = '${month}' 
            AND ed.employee_type = 'Labour Form'
            AND ed.emp_category = 'In-House'`;
    
        if (departmentId) {
            query += ` AND attendance.department_id = '${departmentId}'`;
        }
        if (unitId) {
            query += ` AND attendance.unit_id = '${unitId}'`;
        }
        if(category){
            query += ` AND ed.emp_category = '${category}'`;
        }
    
        query += ` ORDER BY attendance.date`;
    
        const result = await this.query(query);
        return result;
    }
    async getWorkersIncentiveHrsByMonthOfEmp(year: number, month: number,empId:number ): Promise<CommonResponse[]> {
        console.log(year,"year")
        console.log(month,"month")
        console.log(empId,"empId")
        const prevMonth = month - 1
        let query = `SELECT attendance.date, attendance.employee_id, attendance.employee_code, attendance.employee_name,attendance.department_id, attendance.shift,attendance.present_status as presentStatus, attendance.unit_id, attendance.day, ed.employee_type AS employeeType,ed.emp_category,ed.contractor_name AS contractorName, c.total_hours as totalHours FROM `+appSettings.hrms_db +`.attendance
        LEFT JOIN ` + appSettings.masters_db +`.employee_details ed ON attendance.employee_code = ed.employee_code
        LEFT JOIN `+appSettings.hrms_db +`.consolidated_attendance_log c ON c.employee_code = attendance.employee_code AND c.log_date = attendance.date
        WHERE 
            attendance.year= '${year}' 
            AND attendance.month = '${month}' 
            AND ed.employee_type = 'Labour Form'
            AND ed.emp_category = 'In-House'
            AND ed.employee_id = ${empId}`;
    
        
        query += ` ORDER BY attendance.date`;
    
        const result = await this.query(query);
        return result;
    }
    async getNMRIncentiveHrsByMonth(year: number, month: number, departmentId?: number, unitId?: number,category?:string): Promise<CommonResponse[]> {
        const startDate: any = moment(new Date(year, month - 2, 26), "Asia/Calcutta").format('YYYY-MM-DD'); //.toISOString().split('T')[0];
        const endDate: any = moment(new Date(year, month - 1, 25), "Asia/Calcutta").format('YYYY-MM-DD'); // .toISOString().split('T')[0];
        let query = `SELECT attendance.date, attendance.employee_id, attendance.employee_code, attendance.employee_name,attendance.department_id, attendance.shift,attendance.present_status as presentStatus, attendance.unit_id, attendance.day, ed.employee_type AS employeeType,ed.emp_category, c.total_hours as totalHours FROM `+appSettings.hrms_db +`.attendance
        LEFT JOIN ` + appSettings.masters_db +`.employee_details ed ON attendance.employee_code = ed.employee_code
        LEFT JOIN `+appSettings.hrms_db +`.consolidated_attendance_log c ON c.employee_code = attendance.employee_code AND c.log_date = attendance.date
        WHERE 
        attendance.date >= '${startDate}' 
            AND attendance.date <= '${endDate}' 
            AND ed.employee_type = 'Labour Form'
            AND ed.emp_category = 'NMR'`;
            
        if (departmentId) {
            query += ` AND attendance.department_id = '${departmentId}'`;
        }
        if (unitId) {
            query += ` AND attendance.unit_id = '${unitId}'`;
        }
        if(category){
            query += ` AND ed.emp_category = '${category}'`;
        }
    
        query += ` ORDER BY attendance.date`;
    
        const result = await this.query(query);
        return result;
    }

    async getNMRIncentiveHrsByMonthOfEmp(year: number, month: number,empId:number,): Promise<CommonResponse[]> {
        const startDate: any = moment(new Date(year, month - 2, 26), "Asia/Calcutta").format('YYYY-MM-DD'); //.toISOString().split('T')[0];
        const endDate: any = moment(new Date(year, month - 1, 25), "Asia/Calcutta").format('YYYY-MM-DD'); // .toISOString().split('T')[0];
        let query = `SELECT attendance.date, attendance.employee_id, attendance.employee_code, attendance.employee_name,attendance.department_id, attendance.shift,attendance.present_status as presentStatus, attendance.unit_id, attendance.day, ed.employee_type AS employeeType,ed.emp_category, c.total_hours as totalHours FROM `+appSettings.hrms_db +`.attendance
        LEFT JOIN ` + appSettings.masters_db +`.employee_details ed ON attendance.employee_code = ed.employee_code
        LEFT JOIN `+appSettings.hrms_db +`.consolidated_attendance_log c ON c.employee_code = attendance.employee_code AND c.log_date = attendance.date
        WHERE 
        attendance.date >= '${startDate}' 
            AND attendance.date <= '${endDate}' 
            AND ed.employee_type = 'Labour Form'
            AND ed.emp_category = 'NMR'
            AND attendance.employee_id = ${empId}`;
        query += ` ORDER BY attendance.date`;
    
        const result = await this.query(query);
        return result;
    }



    async getNmrAttendanceRecordsByMonth(year: number, month: number, departmentId?: number, unitId?: number, category?:string): Promise<EmployeeAttendanceQueryResponse[]> {
        // Format the start and end dates
        
    
        const startDate: any = moment(new Date(year, month - 2, 26), "Asia/Calcutta").format('YYYY-MM-DD'); //.toISOString().split('T')[0];
        const endDate: any = moment(new Date(year, month - 1, 25), "Asia/Calcutta").format('YYYY-MM-DD'); // .toISOString().split('T')[0];
        // Construct the base query string
        let query = `SELECT 
            attendance.date, 
            attendance.employee_id, 
            attendance.employee_code, 
            attendance.employee_name, 
            attendance.present_status, 
            attendance.department_id, 
            attendance.shift, 
            attendance.unit_id, 
            attendance.day, 
            ew.week_off_day AS weekOffDay,
            ed.employee_type AS employeeType,
            ed.emp_category
        FROM 
            attendance 
        LEFT JOIN 
            employee_week_off_uploads ew 
        ON 
            attendance.employee_code = ew.employee_code 
        LEFT JOIN erpx_dev_masters.employee_details ed
        ON attendance.employee_code = ed.employee_code
        WHERE 
            attendance.date >= '${startDate}' 
            AND attendance.date <= '${endDate}' 
            AND ed.employee_type = 'Labour Form'
            AND ed.emp_category = 'NMR'`;
    
        // Add the optional filters
        if (departmentId) {
            query += ` AND attendance.department_id = '${departmentId}'`;
        }
        if (unitId) {
            query += ` AND attendance.unit_id = '${unitId}'`;
        }

        if(category){
            query += ` AND ed.emp_category = '${category}'`;
        }


    
        // Add the ORDER BY clause
        query += ` ORDER BY attendance.date`;
    
        // Execute the query and return the results
        const result = await this.query(query);
        return result;
    }
    async getNmrMonthRecordsForEmp(year:number,employeeId: number, month: number, departmentId?: string, shift?: string): Promise<EmployeeAttendanceQueryResponse[]> {
        // Calculate the previous month
       
        const startDate: any = moment(new Date(year, month - 2, 26), "Asia/Calcutta").format('YYYY-MM-DD'); //.toISOString().split('T')[0];
        const endDate: any = moment(new Date(year, month - 1, 25), "Asia/Calcutta").format('YYYY-MM-DD'); // .toISOString().split('T')[0];
        const query = this.createQueryBuilder('attendance')
            .select(`date,employee_id, employee_code, employee_name, present_status, department_id, shift, count(1) as count, punch_status`)
            .where(`date >= '${startDate}' AND date <= '${endDate}' AND employee_id = ${employeeId}`);
        
        if (departmentId) {
            query.andWhere(`department_id = ${departmentId}`);
        }
        if (shift) {
            query.andWhere(`shift = ${shift}`);
        }
        
        query.groupBy(`present_status, punch_status`);
    
        return await query.getRawMany();
    }
}